/*@ngInject*/
const GetServerPublicKeySpecRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getServerPublicKeySpec = function () {
        let url = '/rest/Session/serverPublicKeySpec';

        return this.get(url);
    };
};

angular.module('umCore')
    .service('getServerPublicKeySpecRepository', GetServerPublicKeySpecRepository);
